 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		1: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/chunks/" + ({"0":"framework","2":"eae6f35fcab366852a77f1f00310047e04fe07b9","5":"c9c6fe98","6":"fb2645b55c16f7869af7a7384c4bc4476b00a5cf","7":"e8adfd52c7186b74a6407fd11eaa2191ed7e5545","9":"dcea61c57d916fb4849d5b4fe47960bb2fbf6a9d","11":"e378534f944924bb957cbff13fdb9e485009d68f","12":"75fc9c18","13":"cb587b6468196656336b0d2e9a2a1e3226ab0577","16":"24af87c98041e2df45ed82786f333eab0a766568","20":"1b71e3b478f54a1cc4850717986c2c1e9f96663e","21":"395aefadd6d3ca46d869d681072703731c097147","25":"f929a364fc82e5f5a75c1d52bff9d61721290ab0","31":"f31d4b40b0c9891021095bb9291d7071f3c344ca","37":"fb8e0a985f1e2798051d4965d984ea2bb1775ce2","41":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","42":"cae5737e08c1a9948a650822c6a84ae1b82f4d13","43":"d282c9243d032fb2d2ee2da709a47048b1d844db","124":"reactPlayerDailyMotion","125":"reactPlayerFacebook","126":"reactPlayerFilePlayer","127":"reactPlayerKaltura","128":"reactPlayerMixcloud","129":"reactPlayerPreview","130":"reactPlayerSoundCloud","131":"reactPlayerStreamable","132":"reactPlayerTwitch","133":"reactPlayerVidyard","134":"reactPlayerVimeo","135":"reactPlayerWistia","136":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"c79e8c1855af7b4c66de","2":"35789a19467d4a999ffb","5":"f2338c2e0957ba7504e7","6":"4abf5d2f897b87c65035","7":"da1a810922fa19b598b5","9":"263e494e16160e4a780f","11":"d9dba2ff11a6921a18cb","12":"af6c63e5da409560ce9f","13":"8da48aa9fcc3e4946fb3","16":"a240b64e93bb22d9cdf1","20":"9a73b6ad08dc0f94bcf8","21":"b3296d5e5d290b682c52","25":"505142c170175a61d2cb","31":"363dc8e35495744f84f0","37":"4bb836e13759d624da76","41":"9947bc3972a8148a5cbb","42":"9bcba0db7440a544fb5c","43":"a8bb320a1074e6a884cd","44":"df1edf84396522b8604e","45":"fd9e760c3c959294ff22","46":"79ade42caff3fdaefade","47":"c55a62b2d03053696bb3","48":"0b2e3724fbfd826b2283","49":"3a3fd514bfef193aa0ce","50":"6123868a5d221baa80b9","51":"3084da069f2c28171f75","52":"42d0af24a300d3ffeb8a","54":"ca6dc8544a22afe32a60","55":"aaa41e06f3e69383f12a","56":"910594f2b5babb334326","57":"c68515d74a7210b28755","58":"1ccabb04d0e4d22ff801","59":"6ef44e1246c4d0cbd55f","60":"1f8365cfde14d23ada91","61":"329b3c195fa54c5cde96","62":"0178de391173138ecabe","71":"2c65c36bb3f19ce0e48f","72":"957c0e7eed37416427cd","73":"d0f1f629bc8e7d04088e","74":"e879c54b6470c5bf878c","75":"bba6d49fc5f3ccf5d164","124":"7ba27638df511035f3d9","125":"fb1a85af1073ce953f47","126":"15ea8936b4897b8a0f3d","127":"77e2c10d13d74207104a","128":"d5bd2540756d01c295c9","129":"e1325be64b8a54448cfd","130":"cdeb4475df75a2f8190d","131":"ddff6fb6304a9d5f6766","132":"e693ba673c0b82c8c296","133":"ea8d871347596fac5b34","134":"a1811457912289857bee","135":"b82bfc1234ad0aef6616","136":"e3550b1d73554894235a","137":"01415083eff6eca9f9c6","138":"3d5583441ba56892bb7e","139":"a0c17bde362f285695b4","140":"41731eca45408299d017","141":"45053fade6db3a8312a5","142":"e74b3cff2189f624b91c","143":"3ba03a447aeab44852d6","144":"4f66846671734483590d","145":"d9e3684a11639d99602d","146":"3000a95257c0d90eb60c","147":"a152ee981d043e8945b1","148":"9e8a082c0692f3871d10","149":"55e8d67b57109c1a1015","150":"4e8f7b4c41d837ce5de6","151":"d699f5d8b4a3371fd1d4","152":"e8dd5d76a94a7d57f0f6","153":"f1194e3496cc4d03a30b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		var threw = true;
 		try {
 			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 			threw = false;
 		} finally {
 			if(threw) delete installedModules[moduleId];
 		}

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"45":1,"46":1,"48":1,"50":1,"54":1,"55":1,"56":1,"57":1,"59":1,"60":1,"61":1,"62":1,"71":1,"73":1,"137":1,"138":1,"140":1,"141":1,"142":1,"143":1,"144":1,"145":1,"146":1,"147":1,"148":1,"149":1,"152":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + {"0":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"1249ca0e56183c3725b2","46":"9a7d7057e51b7fdb5ccb","47":"31d6cfe0d16ae931b73c","48":"a98420ed4ce9fe4278ff","49":"31d6cfe0d16ae931b73c","50":"a98420ed4ce9fe4278ff","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","54":"6fa308c32e64770d8b5d","55":"6fa308c32e64770d8b5d","56":"a98420ed4ce9fe4278ff","57":"af3ad95c179c89db825d","58":"31d6cfe0d16ae931b73c","59":"af3ad95c179c89db825d","60":"a98420ed4ce9fe4278ff","61":"c48cdba4d1aa30c4d508","62":"c48cdba4d1aa30c4d508","71":"a98420ed4ce9fe4278ff","72":"31d6cfe0d16ae931b73c","73":"af3ad95c179c89db825d","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","124":"31d6cfe0d16ae931b73c","125":"31d6cfe0d16ae931b73c","126":"31d6cfe0d16ae931b73c","127":"31d6cfe0d16ae931b73c","128":"31d6cfe0d16ae931b73c","129":"31d6cfe0d16ae931b73c","130":"31d6cfe0d16ae931b73c","131":"31d6cfe0d16ae931b73c","132":"31d6cfe0d16ae931b73c","133":"31d6cfe0d16ae931b73c","134":"31d6cfe0d16ae931b73c","135":"31d6cfe0d16ae931b73c","136":"31d6cfe0d16ae931b73c","137":"6fa308c32e64770d8b5d","138":"6fa308c32e64770d8b5d","139":"31d6cfe0d16ae931b73c","140":"af3ad95c179c89db825d","141":"6fa308c32e64770d8b5d","142":"1249ca0e56183c3725b2","143":"9a7d7057e51b7fdb5ccb","144":"af3ad95c179c89db825d","145":"5650f4f6f435f156cc9f","146":"a98420ed4ce9fe4278ff","147":"a98420ed4ce9fe4278ff","148":"a98420ed4ce9fe4278ff","149":"c48cdba4d1aa30c4d508","150":"31d6cfe0d16ae931b73c","151":"31d6cfe0d16ae931b73c","152":"a98420ed4ce9fe4278ff","153":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
